import { useDataGridContext } from '@issuemanager/apps/client/components';
import { useEventCallback } from '@mui/material';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { JSX } from 'react';
import { DateFilter } from '../../../../components/filters/date-filter';
import { IssueGridFilterModel } from './types';

export function IssueGridActualRemediationDateFilter(): JSX.Element {
  const context = useDataGridContext();

  const { actualRemediationDate }: IssueGridFilterModel = context.filterModel;

  const handleChange = useEventCallback((value: DateRange<Date>) => {
    context.setFilterModel({
      ...context.filterModel,
      actualRemediationDate: value,
    });
  });

  const value: DateRange<Date> = [
    actualRemediationDate?.[0] ?? null,
    actualRemediationDate?.[1] ?? null,
  ];

  return <DateFilter onChange={handleChange} value={value} />;
}
